import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { scryfallFormats } from '@/lib/formats';

interface PublishConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title: string;
  setTitle: (title: string) => void;
  format: string;
  setFormat: (format: string) => void;
  visibility: 'public' | 'unlisted';
  setVisibility: (visibility: 'public' | 'unlisted') => void;
  isPending: boolean;
}

export const PublishConfirmationDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  setTitle,
  format,
  setFormat,
  visibility,
  setVisibility,
  isPending,
}: PublishConfirmationDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Publish Deck</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label htmlFor="deck-title" className="block text-sm font-medium text-gray-700">
              Title
            </label>
            <Input id="deck-title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Deck Title" />
          </div>
          <div>
            <label htmlFor="deck-format" className="block text-sm font-medium text-gray-700">
              Format
            </label>
            <Select onValueChange={setFormat} value={format}>
              <SelectTrigger id="deck-format">
                <SelectValue placeholder="Format" />
              </SelectTrigger>
              <SelectContent>
                {scryfallFormats.map((f) => (
                  <SelectItem key={f.value} value={f.value}>
                    {f.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label htmlFor="deck-visibility" className="block text-sm font-medium text-gray-700">
              Visibility
            </label>
            <Select onValueChange={(value: 'public' | 'unlisted') => setVisibility(value)} value={visibility}>
              <SelectTrigger id="deck-visibility">
                <SelectValue placeholder="Visibility" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="public">Public</SelectItem>
                <SelectItem value="unlisted">Unlisted</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter className="flex-col-reverse sm:flex-row sm:justify-center sm:space-x-2">
          <DialogClose asChild>
            <Button type="button" variant="outline">
              Cancel
            </Button>
          </DialogClose>
          <Button
            onClick={onConfirm}
            disabled={isPending}
            className="bg-gradient-to-r from-blue-800 to-slate-900 text-slate-200 hover:from-blue-700 hover:to-slate-800 transition-all duration-300 ease-in-out transform hover:scale-105"
          >
            {isPending ? 'Publishing...' : 'Confirm Publish'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
